import { setCrqSponsor } from './sponsor-queries';

const SET_CRQ_SPONSOR_REQUEST = 'SET_CRQ_SPONSOR_REQUEST';
const SET_CRQ_SPONSOR_SUCCESS = 'SET_CRQ_SPONSOR_SUCCESS';
const SET_CRQ_SPONSOR_ERROR = 'SET_CRQ_SPONSOR_ERROR';

const setCrqSponsorRequest = (network, crqId) => ({
  type: SET_CRQ_SPONSOR_REQUEST,
  payload: {
    network,
    crqId,
  },
});

const setCrqSponsorSuccess = (network, crqId) => ({
  type: SET_CRQ_SPONSOR_SUCCESS,
  payload: {
    network,
    crqId,
  },
});

const setCrqSponsorError = (network, crqId, error) => ({
  type: SET_CRQ_SPONSOR_ERROR,
  payload: {
    network,
    crqId,
    error,
  },
});

// thunk action to update sponsor for an existing crq
const setSponsorForCrq = ({
  crqId,
  sponsor,
  network,
}) => (dispatch, getState) => {
  dispatch(setCrqSponsorRequest(network, crqId));
  return setCrqSponsor({
    email: sponsor,
    crqId,
    network,
  })
    .then(() => {
      dispatch(setCrqSponsorSuccess(network, crqId));
    })
    .catch((error) => {
      console.error(error);
      dispatch(setCrqSponsorError(network, crqId, error));
      return Promise.reject(error);
    });
};

export {
  SET_CRQ_SPONSOR_REQUEST,
  SET_CRQ_SPONSOR_SUCCESS,
  SET_CRQ_SPONSOR_ERROR,
  setCrqSponsorRequest,
  setCrqSponsorSuccess,
  setCrqSponsorError,
  setSponsorForCrq,
};
